import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CustomerAuthProvider } from './context/CustomerAuthContext';
import AdminPanel from './components/AdminPanel';
import EmbeddedChatbot from './components/EmbeddedChatbot';
import StepperChatbotWidget from './components/StepperChatbotWidget';
import OfferDisplay from './components/OfferDisplay';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import AdminConversations from './components/AdminConversations';
import AdminOfferView from './components/AdminOfferView';
import AdminMonitoring from './components/AdminMonitoring';
import AdminAnalytics from './components/AdminAnalytics';
import AdminPrompts from './components/AdminPrompts';
import AdminDocumentation from './components/AdminDocumentation';
import CustomerLogin from './components/CustomerLogin';
import CustomerPortal from './components/CustomerPortal';
import CustomerOffersList from './components/CustomerOffersList';
import CustomerOfferDetail from './components/CustomerOfferDetail';
import CustomerProtectedRoute from './components/CustomerProtectedRoute';

function AppRoutes() {
  const location = useLocation();
  const isEmbedRoute = location.pathname.startsWith('/embed/');
  return (
    <div className={isEmbedRoute ? 'min-h-0 bg-transparent' : 'min-h-screen bg-gray-50'}>
      <Routes>
              {/* Admin Routes */}
              <Route path="/login" element={<Login />} />
              <Route 
                path="/" 
                element={
                  <Navigate to="/admin/chatbots" replace />
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <Navigate to="/admin/chatbots" replace />
                } 
              />
              <Route 
                path="/admin/chatbots" 
                element={
                  <ProtectedRoute>
                    <AdminPanel />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/admin/prompts" 
                element={
                  <ProtectedRoute>
                    <AdminPrompts />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/admin/conversations"
                element={
                  <ProtectedRoute>
                    <AdminConversations />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/admin/offers/:offerId"
                element={
                  <ProtectedRoute>
                    <AdminOfferView />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/admin/monitoring" 
                element={
                  <ProtectedRoute>
                    <AdminMonitoring />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/analytics" 
                element={
                  <ProtectedRoute>
                    <AdminAnalytics />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/admin/documentation"
                element={
                  <ProtectedRoute>
                    <AdminDocumentation />
                  </ProtectedRoute>
                }
              />

              {/* Customer Routes */}
              <Route path="/customer/login" element={<CustomerLogin />} />
              <Route 
                path="/customer/portal" 
                element={
                  <CustomerProtectedRoute>
                    <CustomerPortal />
                  </CustomerProtectedRoute>
                } 
              />
              <Route 
                path="/customer/offers" 
                element={
                  <CustomerProtectedRoute>
                    <CustomerOffersList />
                  </CustomerProtectedRoute>
                } 
              />
              <Route 
                path="/customer/offers/:offerId" 
                element={
                  <CustomerProtectedRoute>
                    <CustomerOfferDetail />
                  </CustomerProtectedRoute>
                } 
              />

              {/* Public Routes */}
              <Route path="/embed/:chatbotId/stepper" element={<StepperChatbotWidget />} />
              <Route path="/embed/:chatbotId" element={<EmbeddedChatbot />} />
              <Route path="/offer/:offerId" element={<OfferDisplay />} />
              <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CustomerAuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </CustomerAuthProvider>
    </AuthProvider>
  );
}

export default App; 